import { Box } from 'ink';
import TableEnd from './TableEnd';
import TableHead from './TableHead';
import TableBody from './TableBody';
import getKeyDetails from './getKeyDetails';
import type { DataItems, GetCellTextProps } from './tableTypes';

/*
  This component prints (the array of objects given) in a table.
  The array must not be empty.
  The keys are used as headers.
  Column widths are based on the longest value (object key or value).
  It is assumed that the same keys exist in all items.
*/
export default function Table({
  data,
  getCellTextProps,
}: {
  data: DataItems;
  getCellTextProps?: GetCellTextProps;
}) {
  const keyDetails = getKeyDetails(data);

  return (
    <Box flexDirection="column">
      <TableHead keyDetails={keyDetails} />
      <TableBody
        data={data}
        getCellTextProps={getCellTextProps}
        keyDetails={keyDetails}
      />
      <TableEnd keyDetails={keyDetails} />
    </Box>
  );
}
